import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import localize from '../../util/localizeUtils';
import { ErrorMessage } from './styled-components';

const Container = styled.div`
  display: ${props => (props.visible ? 'block' : 'none')};
`;

class CharacterLimit extends React.PureComponent {
  render() {
    const { currentLength, max, visible } = this.props;
    const exceedsLimit = currentLength > max;
    return (
      <Container visible={visible || exceedsLimit}>
        {currentLength}/{max}
        <ErrorMessage visible={exceedsLimit}>
          {localize('characterLimitErrorFormat').replace('{max}', max).replace('{currentLength}', currentLength)}
        </ErrorMessage>
      </Container>
    );
  }
}

CharacterLimit.propTypes = {
  currentLength: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  visible: PropTypes.bool
};

CharacterLimit.defaultProps = {
  visible: true
};

export default CharacterLimit;



// WEBPACK FOOTER //
// ./app/components/PublishingDialog/CharacterLimit.js